import React, { useState } from 'react';
import chatApi from '../../services/chatApi';
import './StickerPicker.css';

const StickerPicker = ({ packs, onSelect, onClose }) => {
  const [activePackId, setActivePackId] = useState(packs[0]?.id ?? null);

  const activePack = packs.find(p => p.id === activePackId);

  if (!packs.length) {
    return (
      <div className="sticker-picker">
        <div className="sticker-picker-empty">Стикеров пока нет</div>
      </div>
    );
  }

  return (
    <>
      {/* Backdrop */}
      <div className="sticker-picker-backdrop" onClick={onClose} />

      <div className="sticker-picker">
        {/* Tabs */}
        <div className="sticker-picker-tabs">
          {packs.map(pack => (
            <button
              key={pack.id}
              className={`sticker-tab ${pack.id === activePackId ? 'sticker-tab--active' : ''}`}
              onClick={() => setActivePackId(pack.id)}
              title={pack.name}
            >
              {pack.stickers[0] ? (
                <img
                  src={chatApi.getStickerUrl(pack.stickers[0].filename)}
                  alt={pack.name}
                  className="sticker-tab-thumb"
                />
              ) : (
                <span className="sticker-tab-icon">📦</span>
              )}
            </button>
          ))}
        </div>

        {/* Pack name */}
        <div className="sticker-pack-name">{activePack?.name}</div>

        {/* Sticker grid */}
        <div className="sticker-grid">
          {activePack?.stickers.map(sticker => (
            <button
              key={sticker.id}
              className="sticker-item"
              onClick={() => {
                onSelect(sticker.filename);
                onClose();
              }}
            >
              <img
                src={chatApi.getStickerUrl(sticker.filename)}
                alt="sticker"
                className="sticker-img"
                loading="lazy"
              />
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default StickerPicker;
